import {
  SEND_MY_CURRENT_LOCATION,
  SEND_MY_CURRENT_LOCATION_SUCCESS,
  SEND_MY_CURRENT_LOCATION_FAILURE,
} from "./actionType";

//initial state
const initialState = {
  sendMyCurrentLocationReceived: [],
  sendMyCurrentLocationError: "",
  sendMyCurrentLocationLoading: false,
};

//Reducer

const GPS = (state = initialState, { type, payload }) => {
  switch (type) {
    case SEND_MY_CURRENT_LOCATION:
      return {
        ...state,
        sendMyCurrentLocationLoading: true,
      };
    case SEND_MY_CURRENT_LOCATION_SUCCESS:
      return {
        ...state,
        sendMyCurrentLocationReceived: payload,
        sendMyCurrentLocationLoading: false,
      };
    case SEND_MY_CURRENT_LOCATION_FAILURE:
      return {
        ...state,
        sendMyCurrentLocationError: payload,
        sendMyCurrentLocationLoading: false,
      };

    default:
      return state;
  }
};

export default GPS;
